import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const SkinQuiz = () => {
  return (
    <section className="bg-[#f5eee6] py-20 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f] mb-4"
        >
          Not Sure What Your Skin Needs?
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="text-[#7a6e5f] opacity-80 mb-8 max-w-xl mx-auto"
        >
          Take our quick quiz and let us match you with skincare that truly gets you.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <Link
            to="/quiz"
            className="inline-block bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6d7d6d] transition-colors font-medium"
          >
            Take the Skin Quiz
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default SkinQuiz;
